import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppFileContainer from '../../../components/designe/app-file-container/AppFileContainer';
import AppFormSelectWrapper from '../../../components/designe/forms/app-form-select-wrapper';
import AppFormTextField from '../../../components/designe/forms/app-form-text-field';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../components/layout/page-container/page-container-error-handler';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useStyles } from './NewBugReport.styles';
import { useNewBugReportPage } from './useNewBugReportPage';

export default function NewBugReport(props) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { back } = useNavigationStack();
  const {
    formik,
    types,
    filePaths,
    isLoading,
    onFilesToUploadChanged,
    refetchTypes,
    refetchFilePaths,
    isLoadingTypes,
    isFetchingTypes,
    isErrorTypes,
    typesError,
    isLoadingFilePaths,
    isFetchingFilePaths,
    isErrorFilePaths,
    filePathsError,
  } = useNewBugReportPage();
  const handleRetry = useCallback(() => {
    void refetchTypes();
    void refetchFilePaths();
  }, [refetchFilePaths, refetchTypes]);

  useRegisterPageContainerError({
    errors: [
      ...(isErrorTypes && typesError ? [typesError] : []),
      ...(isErrorFilePaths && filePathsError ? [filePathsError] : []),
    ],
    isLoading:
      isLoadingTypes ||
      isFetchingTypes ||
      isLoadingFilePaths ||
      isFetchingFilePaths,
    hasData: Boolean(types?.length) && Boolean(filePaths),
    onRetry: handleRetry,
  });

  return (
    <PageContainer title={t('bugReport.newBugReport')}>
      <form onSubmit={formik.handleSubmit}>
        <Box className={classes.newBugWrapper}>
          <AppFormTextField
            label={t('bugReport.title')}
            fullWidth
            multiline
            name="title"
            formik={formik}
          />

          <AppFormSelectWrapper
            label={t('bugReport.type')}
            options={types}
            name="type"
            formik={formik}
          />

          <AppFormTextField
            label={t('bugReport.describeProblem')}
            fullWidth
            multiline
            minRows={3}
            name="message"
            formik={formik}
          />

          <Box marginTop={1}>
            <Typography variant="label-text-sm">
              {t('bugReport.addFiles')}
            </Typography>
          </Box>

          <AppFileContainer
            files={[]}
            editMode={true}
            onFilesToUploadChanged={onFilesToUploadChanged}
          />
          <AppBarWithButtons loading={isLoading} onCancelClick={() => back()} />
        </Box>
      </form>
    </PageContainer>
  );
}
